import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import {Paper, Container, Grid, Typography} from '@material-ui/core';
import {axiosInstance} from 'utils/auth.service';
import './UsedCouponCodes.scss';

const Coupon = ({coupon, used = false}) => {
  const {t} = useTranslation();

  const dateParser = (start, end) => {
    let rtn = '';
    if (start) {
      rtn = t(' à partir du ') + moment(start).format('DD/MM/YYYY');
    }
    if (end) {
      rtn = t(" jusqu'au ") + moment(end).format('DD/MM/YYYY');
    }
    return rtn === '' ? rtn : rtn + ',';
  };

  const validPlaceParser = (cinemas, films) => {
    let rtn = '';
    if (cinemas && cinemas.length) {
      rtn += `${t(' dans le(s) cinéma(s) ')}${cinemas.reduce((acc, cinema) => acc + cinema.name, '')}`;
    }
    if (films && films.length) {
      rtn += `${t(' dans le(s) film(s) ')}${films.reduce((acc, film) => acc + film.name, '')}`;
    }
    return rtn;
  };

  return (
    <Grid item xs={12} key={coupon.id}>
      <div className="coupon-container">
        <div className="code">
          <span className="coupon-code">{coupon.value}</span>
        </div>
        <div className="coupon-detail">
          {used ? t('Utilisé ') : t('Utilisable ')}
          {used
            ? coupon.discount_code_front_users?.length || 0
            : coupon.group.max_usage_user - coupon.discount_code_front_users?.length}
          {t(' fois ')}
          <span>{dateParser(coupon.group.start_time, coupon.group.end_time)}</span>
          {validPlaceParser(coupon.group.cinemas, coupon.group.films) || null}
        </div>
        <div>
          {t('Nombre d utilisation') + ' : '}
          <span className="coupon-usage">
            {coupon.discount_code_front_users?.length || 0}/{coupon.group.max_usage_user || 0}
          </span>
        </div>
      </div>
    </Grid>
  );
};

const UsedCouponCodes = () => {
  const {t} = useTranslation();
  const [toBeUsed, setToBeUsed] = useState([]);
  const [used, setUsed] = useState([]);

  const sortCoupons = coupons => {
    let toBeUsed = [];
    let used = [];
    coupons.forEach(coupon => {
      if (
        coupon.discount_code_front_users?.length < coupon.group.max_usage_user &&
        (coupon.group.end_time === null || coupon.group.end_time > new Date().getTime())
      ) {
        toBeUsed.push(coupon);
      } else {
        used.push(coupon);
      }
    });
    setToBeUsed(toBeUsed);
    setUsed(used);
  };

  useEffect(() => {
    axiosInstance.get('/discount_codes').then(res => {
      if (res.data) {
        sortCoupons(res.data);
      }
    });
  }, []);

  return (
    <Paper>
      <Container>
        <div className="spacer" />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h4">{t('mes-codes-promos-actifs')}</Typography>
          </Grid>
          {toBeUsed.length === 0 && (
            <Grid item xs={12}>
              <div>{t('pas-de-codes-promos-actifs')}</div>
            </Grid>
          )}
          {toBeUsed.map(coupon => (
            <Coupon coupon={coupon} key={coupon.id} />
          ))}
          <div className="spacer" />
          <Grid item xs={12}>
            <Typography variant="h4">{t('mes-codes-promos-expirés')}</Typography>
          </Grid>
          {used.length === 0 && (
            <Grid item xs={12}>
              <div>{t('pas-de-codes-expirés')}</div>
            </Grid>
          )}
          {used.map(coupon => (
            <Coupon used coupon={coupon} key={coupon.id} />
          ))}
        </Grid>
      </Container>
    </Paper>
  );
};

export default UsedCouponCodes;
